module.exports = __webpack_public_path__ + "static/img/ban02.3f9866f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ban02.jpeg
// module id = YIin
// module chunks = 6